<template>
  <div class="sfhome">
    <div class="header"></div>
    <div class="blackbg"></div>
    <div class="sp2"></div>
    <div class="con">
      <div class="spa1"></div>
      <div class="conin">
        <div class="item1">
          <div class="sp3"></div>
          <div class="item1in">
            <div class="left" @click="gotoSend">
              <div class="l1">
                <img src="../../../assets/img/common/fly.png" />
              </div>
              <div class="l2">
                <div class="sp4"></div>
                <div class="t1">寄快递</div>
                <div class="t2">一小时内取件</div>
              </div>
            </div>
            <div class="right" @click="gotoSearch">
              <div class="l1">
                <img src="../../../assets/img/common/search.png" />
              </div>
              <div class="l2">
                <div class="sp4"></div>
                <div class="t1">查快递</div>
                <div class="t2">显示近三个月</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="conin">
        <div class="zitem" @click="jumpCoupons">
          <img src="../../../assets/img/common/coupon.png" />
          优惠券
        </div>
        <div class="zitem zitem2" @click="jumpWaitPay">
          <img src="../../../assets/img/common/waipay.png" />
          待支付
          <div class="round" v-show="not_pay_orders !== ''">{{not_pay_orders}}</div>
        </div>
      </div>
    </div>
    <Footer :active="'home'"></Footer>
  </div>
</template>
<script>
import Footer from '../components/footer'
import { nhlogin, personalInfo } from '@/api/modules/user'
export default {
  name: 'sfheader',
  components: {
    Footer
  },
  data() {
    return {
      online: true,
      track: false,
      not_pay_orders: ''
    }
  },
  computed: {
  },
  created() {
    if (window.location.href.indexOf('http://localhost') === 0) {
      this.online = false
    }
    this.autoLogin()
  },
  methods: {
    getPersonInfo() {
      personalInfo().then((res) => {
        if (res.data.status_code === 200) {
          this.not_pay_orders = res.data.not_pay_orders
        }
        if (res.code === 404) {
          this.nohangLogin()
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    nohangLogin() {
      let options = {
        'version_tag': 'touch',
        'trushlogin_tag': 'nonghang',
        'redirect_url': encodeURIComponent(window.location.href)
      }
      if (this.online === false) {
        options.mobile = '18049901119'
      }
      nhlogin(options).then((res) => {
        if (this.online === false) {
          localStorage.setItem('TOKEN', 'Bearer ' + res.data.token)
        }
        else {
          if (res.data && res.data.oauth_url) {
            window.location.href = res.data.oauth_url
          }
        }
      })
    },
    autoLogin() {
      const queryParams = new URLSearchParams(window.location.search)
      const token = queryParams.get('token')
      if (token) {
        localStorage.setItem('token', token)
      }
      if (localStorage.getItem('token')) {
        localStorage.setItem('TOKEN', 'Bearer ' + localStorage.getItem('token'))
        this.getPersonInfo()
      }
      else {
        this.nohangLogin()
      }
    },
    jumpCoupons() {
      this.$router.push('/sf/coupons')
    },
    jumpWaitPay() {
      this.$router.push('/sf/waitpay')
    },
    gotoSend() {
      // sf/addexpress
      this.$router.push('/sf/addexpress')
    },
    gotoSearch() {
      this.$router.push('/sf/search')
    }
  }
}
</script>
<style lang="less" scoped>
  .sfhome{
    width:100%;
    min-height:100vh;
    background-color:#f4f5fb;
    .sp2{
      height:35px;
    }
    .header{
      width:100%;
      height:556px;
      background-image: url("../../../assets/img/common/bg3.png");
      background-repeat: no-repeat;
      background-size:100% auto;
    }
    .blackbg{
      position:absolute;
      top:456px;
      background-image: url("../../../assets/img/common/banner.png");
      background-repeat: no-repeat;
      background-size:100% auto;
      width:100%;
      height:103px;
    }
    .con{
      margin:0px 21px;
      .item1{
        height: 204px;
        background: #FFFFFF;
        border-radius: 15px;
        .sp3{
          height:33px;
        }
        .item1in{
          margin:0px 34px;
          height:130px;
          display:flex;
          .t1{
            font-weight: bold;
            font-size: 30px;
            color: #000000;
            margin-bottom:16px;
          }
          .t2{
            font-weight: 500;
            font-size: 18px;
            color: #000000;
          }
          .l1{
            img{
              width:130px;
              height:auto;
            }
          }
          .l2{
            margin-left:20px;
            .sp4{
              height:30px;
            }
          }
          .left{
            flex:1;
            border-right:1px solid #000000;
            display:flex;
          }
          .right{
            flex:1;
            display:flex;
            .l1{
              margin-left:40px;
            }
          }
        }
      }
      .zitem{
        width: 346px;
        height: 92px;
        background: #FFFFFF;
        border-radius: 10px;
        float:left;
        text-align:center;
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height:90px;
        img{
          width:60px;
          height:60px;
          margin-right:20px;
          vertical-align: middle;
        }
      }
      .conin{
        margin-bottom:20px;
      }
      .zitem2{
        float:right;
        position:relative;
        .round{
          position:absolute;
          width:24px;
          height:24px;
          right:10px;
          top:10px;
          background-color:#FF0000;
          line-height:24px;
          border-radius: 24px;
          color:#ffffff;
        }
      }
    }
  }

</style>
